import React, { useEffect } from 'react'
import TimeOffBalance from './TimeOffBalance'
import { EmployeeInfo } from './EmployeeInfo'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import TimeOffRequestDetail from './StatusViews/TimeOffRequestDetail'
import BreadCrumbs from "../../components/common/BreadCrumbs/BreadCrumbs";
import Loader from '../../components/common/Loader'
import ValidationBanner from '../../components/common/ValidationBanner'
import { RootState, AppDispatch } from '../../store/store'
import { getTimeOffDetails, clearTimeOffDetails } from '../../store/slices/Requestor/timeOffDetailsSlice'

const RequestStatusSummary: React.FC = () => {
  const { id, mode } = useParams<{ id: string; mode?: string }>()
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch<AppDispatch>()

  const { data, loading, error, errorStatus } = useSelector((state: RootState) => state.timeOffDetails)

  // Refetch whenever the route is (re)entered — keyed on both `id` and
  // `location.key`. Saving a draft in place navigates back to this same
  // `status/:id` route; because `id` is unchanged, keying on `location.key`
  // ensures the freshly persisted hours are reloaded instead of serving stale
  // Redux data (which previously only refreshed after navigating fully away).
  useEffect(() => {
    if (id) {
      dispatch(getTimeOffDetails(id))
    }
    return () => {
      dispatch(clearTimeOffDetails())
    }
  }, [dispatch, id, location.key])

  const handleBreadcrumbPrevious = () => {
    const basePath = mode ? `/${mode}/requestor` : '/requestor'
    navigate(basePath)
  }

  const errorMessage =
    errorStatus === 404 || errorStatus === 403
      ? error
      : "We're having a technical problem loading this request. Please try again, or contact the Help Desk for assistance."

  return (
    <div className="page-container">
      <BreadCrumbs
        previousPage="TORT"
        currentPage="Request Detail"
        onPreviousClick={handleBreadcrumbPrevious}
      />

      <div className="mt-4">
        {loading && <Loader />}
        {error && (
          <ValidationBanner
            variant="error"
            message={errorMessage}
            compact={false}
          />
        )}
        {!loading && !error && data && <TimeOffRequestDetail data={data} />}
      </div>
      <TimeOffBalance />
      <EmployeeInfo />
    </div>
  )
}

export default RequestStatusSummary

